<template>
    <transition name="slide-fade">
        <div class="flex items-center relative border-t-4 mb-6 mr-6 px-4 py-3 shadow-md" :class="alertClasses" role="alert" :id="id" v-show="show" @click="close">
            <font-awesome-icon fixed-width class="h-6 w-6" :icon="alertIcon"></font-awesome-icon>
            <div class="ml-3">
                <strong v-text="alertText"></strong> {{ body }}
            </div>
        </div>
    </transition>
</template>

<script>
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faCircleXmark, faCircleCheck, faCircleExclamation } from '@fortawesome/free-solid-svg-icons';

    export default {
        props: ['id', 'alertData'],
        data() {
            return {
                body: '',
                level: 'success',
                show: false
            }
        },
        created() {
            library.add(faCircleXmark, faCircleCheck, faCircleExclamation);

            if(this.alertData) {
                this.feedback(this.alertData);
            }
        },

        computed: {
            alertClasses() {
                if(this.level === 'success') return ['bg-green-100', 'border-green-500', 'text-green-900'];
                else if(this.level === 'danger') return ['bg-red-100', 'border-red-500', 'text-red-900'];
                else if(this.level === 'warning') return ['bg-orange-100', 'border-orange-500', 'text-orange-900'];
                else return ['bg-blue-100', 'border-blue-500', 'text-blue-900'];
            },

            alertText() {
                if(this.level === 'success') return 'Success!';
                else if(this.level === 'danger') return '';
                else return null;
            },

            alertIcon() {
                if(this.level === "danger") {
                    return 'circle-times';
                } else if (this.level === "success") {
                    return 'circle-check';
                } else {
                    return 'circle-exclamation';
                }
            }
        },

        methods: {
            feedback(data) {
                if (data) {
                    this.body = data.message;
                    this.level = data.level;
                    this.show = true;
                    this.hide();
                }
            },

            hide() {
                setTimeout(() => {
                    this.show = false;
                }, 5000);

                setTimeout(() => {
                    this.$emit('closeFeedback');
                }, 6000);
            },

            close() {
                this.show = false;
                this.$emit('closeFeedback');
            }
        }
    };
</script>

<style scoped>
    .shadow-md {
        box-shadow: 0 4px 6px -1px rgba(0,0,0, 0.5), 0 2px 4px -1px rgba(0,0,0,0.25);
    }
</style>
